import { ContentPage, Page, SubPage } from "interfaces/content";

/**
 * @desc findSubPage Fn finds a sub-page tab based on a sub-page url-segment.
 */
export const findSubPage = (page: Page, subPageUrlSegment: string): ContentPage | undefined =>
    page.subPages
        ? page.subPages.find((subPage: SubPage) => subPage.urlSegment === subPageUrlSegment)
        : undefined;
